export default "__VITE_ASSET__e8c01411__"